import React from 'react';
import PropTypes from 'prop-types';

// components
import FormattedPrice from '../../../global/FormattedPrice/FormattedPrice';
import { priceLabel, discountLabel } from '../../messages/pdpPriceMessages';

// styles
import styles from './PdpSharedSidebarPriceAmount.scss';

// helpers
import classnames from 'classnames';

function PdpSharedSidebarPriceAmount({
    amount,
    currency,
    discount,
    hasNetPrice,
    hasSalePrice,
    hasPrivateOffer,
    quantityDisplay,
    showLabel,
    expiration,
    type,
}) {
    const className = classnames({
        [styles.retail]: type === 'RETAIL',
        [styles.net]: type === 'NET',
        [styles.hasNet]: hasNetPrice,
        [styles.hasSale]: hasSalePrice,
        [styles.hasPrivateOffer]: hasPrivateOffer,
    });

    return (
        <div className={className} data-tn={`pdp-pur-${type.toLowerCase()}`}>
            {/* Price */}
            <FormattedPrice value={amount} currency={currency} />
            {/* List Price */}
            {showLabel && <span className={styles.label}>{priceLabel(type)}</span>}
            {/* Quantity */}
            {quantityDisplay && <span className={styles.label}>{quantityDisplay}</span>}
            {/* Percent Off */}
            {discount && <span className={styles.discount}>{discountLabel(discount)}</span>}
            {/* Expiration Date for Private Offers */}
            {expiration && <span className={styles.expiration}>{expiration}</span>}
        </div>
    );
}

PdpSharedSidebarPriceAmount.propTypes = {
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    discount: PropTypes.number,

    type: PropTypes.string,
    hasNetPrice: PropTypes.bool,
    hasSalePrice: PropTypes.bool,
    hasPrivateOffer: PropTypes.bool,

    // options
    quantityDisplay: PropTypes.string,
    showLabel: PropTypes.bool,
    expiration: PropTypes.node,
};

PdpSharedSidebarPriceAmount.defaultProps = {
    amount: 0,
    type: 'RETAIL',
};

export default PdpSharedSidebarPriceAmount;
